import axios from "axios";
import { signedGet, signedPost, signedDelete } from "./signedRequest";

const API = process.env.REACT_APP_BACKEND_URL || "";

const normalizeProfileContentItem = (item) => {
  if (!item || typeof item !== "object") return item;

  if (item.kind !== "image" && item.kind !== "video") {
    return item;
  }

  const existingCaption =
    typeof item.caption === "string" && item.caption.trim()
      ? item.caption.trim()
      : null;

  const textCaption =
    typeof item.textContent === "string" && item.textContent.trim()
      ? item.textContent.trim()
      : null;

  return {
    ...item,
    caption: existingCaption || textCaption,
  };
};


export async function createProfileContent({
  kind,
  textContent = null,
  objectKey = null,
}) {
  const body = {
    kind,
    textContent:
      typeof textContent === "string" && textContent.trim()
        ? textContent.trim()
        : null,
    objectKey:
      typeof objectKey === "string" && objectKey.trim()
        ? objectKey.trim()
        : null,
  };

  const r = await signedPost(
    "/api/v1/profiles/me/content",
    body,
  );

  return r.data?.content || r.data || null;
}

export async function fetchOwnProfileContents() {
  const r = await signedGet(
    "/api/v1/profiles/me/content",
  );

  return Array.isArray(r.data?.items)
    ? r.data.items.map(normalizeProfileContentItem)
    : [];
}

export async function fetchProfileContents(identityId) {
  if (!identityId) return [];

  const r = await axios.get(
    `${API}/api/v1/profiles/${encodeURIComponent(identityId)}/content`,
  );

  return Array.isArray(r.data?.items)
    ? r.data.items.map(normalizeProfileContentItem)
    : [];
}

export async function deleteProfileContent(contentId) {
  if (!contentId) {
    throw new Error("ID contenuto mancante");
  }

  const r = await signedDelete(
    `/api/v1/profiles/me/content/${encodeURIComponent(contentId)}`,
  );

  return r.data;
}
